//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapActions } from 'vuex'
import { axiosGet } from '../../axios/axios.js'
import UpdatesManager from '../../components/UpdatesManager.js'

export default {
  data: function () {
    return {
      loadingFaulties: false,

      hasFaulties: false,

      updatesManager: new UpdatesManager({
        autoUpdate: true,
        updateFn: () => {
          return this.loadFaulties()
        },
        listenDocumentVisibility: true
      })
    }
  },
  created: function () {
    this.updatesManager.onUpdate()
  },
  beforeDestroy: function () {
    this.updatesManager.destroy()
  },
  methods: {
    ...mapActions({
      setHasFaulties: 'setHasFaulties'
    }),
    loadFaulties: function () {
      this.loadingFaulties = true
      if (this.$store.getters.getUser.employee) {
        return axiosGet({
          url: '/service/delta/workqualityreview/hasfaulties?employeeId=' + this.$store.getters.getUser.employee.id,
          onSuccess: (response) => {
            const result = response.data.hasfaulties
            this.hasFaulties = result
            this.setHasFaulties(this.hasFaulties)
          }
        }).finally(() => {
          this.loadingFaulties = false
        })
      } else {
        this.loadingFaulties = false
        this.hasFaulties = false
        return Promise.resolve()
      }
    },
    onClick: async function () {
      this.$router.push('/user-faulties')
    }
  }
}

